(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"]) return;
  try {
    
	$(document).ready(function(){
		$(".staff-block").first().prepend('<nav id="staff-block-nav"></nav>');
		$(".staff-block").each(function(){
			$('#staff-block-nav').append('<a class="staff-block-link" href="#'+$(this).attr('id')+'">'+$(this).find('.page-title').text()+'</a>');
		});

    	// smooth scroll to target
        jQuery('.staff-block-link').on('click',function (e) {
          e.preventDefault();

          var $headerHeight = $('nav.sticky').first().height();

          jQuery('html, body').stop().animate({
              'scrollTop': jQuery( jQuery.attr(this, 'href') ).offset().top - $headerHeight
          }, 500, 'swing' );
        });
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-image-home"] && !Shopify.designMode) return;
  try {
    
$(function () {
    var sliderBlock = {
        init: function () {
            var slider = $('.banner-slider');
            if (slider) {
                slider.slick({
					dots: true,
					speed: 500,
					autoplay: true,
					autoplaySpeed: 6000,
					responsive: [
                      {
                        breakpoint: 768,
                        settings: {
                          arrows: false,
						  dots: false
                        }
                      }
					]
				});
            }
        },
        select: function (blockTarget) {
			var slider = $('.banner-slider');
			blockTarget = $(blockTarget);
			var blockIndex = blockTarget.attr('data-slick-index');

			slider.slick('slickGoTo', parseInt(blockIndex));

            slider.slick('slickPause');

        },
        deselect: function () {
            var slider = $('.banner-slider');
            if (slider) {
                slider.slick('slickPlay');
            }
        }
    }
    sliderBlock.init();

    $(document)
        .on('shopify:section:load', function (e) {

            sliderBlock.init();

        })
		.on('shopify:block:select', function (e) {

			var blockTarget = e.originalEvent.target;
			sliderBlock.select(blockTarget);

        })
        .on('shopify:block:deselect', function (e) {

            sliderBlock.deselect();

        });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  $('.footer-submit-ajax').click(function(e) {
    e.preventDefault();

    if ($('.footer-newsletter [name="EMAIL"]').val()) {
      $('.footer-newsletter p').html('Processing...');
      $.ajax({
        type: 'get',
        url: '//thomasandthomas.us4.list-manage.com/subscribe/post-json?u=27857282f6522e099653cf38d&amp;id=f0c920692c&c=?',
        data: $( ".footer-form" ).serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { 
          $('.footer-newsletter p').html(err.msg); 
        },
        success     : function(data) {
          if (data.result != "success") {
            $('.footer-newsletter p').html(data.msg);
          } else {
            $('.footer-newsletter p').html("You've signed up for our newsletter.");
          }
        }
      });
    } else {
      $('.footer-newsletter p').html('Please fill out out required fields');
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"]) return;
  try {
    

$(document)
.ready(function(){
	var $gallery = $('.gallery').imagesLoaded( function() {
      // init Isotope when grid's images have loaded
      $gallery.isotope({
        // options
        itemSelector: '.gallery-item',
        layoutMode: 'masonry'
      });
    });

    
    $('.lightbox').magnificPopup({
        gallery:{
        enabled:true
        },
        type:'image',
        image: {
        // options for image content type
        titleSrc: 'title'
        },
        preloader: true
    });
})

.on('shopify:section:load', function (e) {

	var $gallery = $('.gallery').imagesLoaded( function() {
      // init Isotope when grid's images have loaded
      $gallery.isotope({
        // options
        itemSelector: '.gallery-item',
        layoutMode: 'masonry'
      });
    });

});
				

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection"] && !Shopify.designMode) return;
  try {
    
$(function () {
    var productSliderBlock = {
        init: function () {
            var slider = $('.product-slider');
            if (slider) {
                slider.slick({
					dots: true,
					arrows: false,
					speed: 500,
					autoplay: false,
					autoplaySpeed: 6000,
					adaptiveHeight: true,
					infinite: true,
					responsive: [
                      {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          dots: false,
						  arrows: true
                        }
                      }
                  ]
				});
            }
        },
        select: function (blockTarget) {
			var slider = $('.product-slider'),
				$blockTarget = $(blockTarget);
			var blockIndex = $blockTarget.attr('data-slick-index');

			slider.slick('slickGoTo', parseInt(blockIndex));

            slider.slick('slickPause');

        },
        deselect: function () {
            var slider = $('.product-slider');
            if (slider) {
                slider.slick('slickPlay');
            }
        }
    }
    productSliderBlock.init();

    $(document)
        .on('shopify:section:load', function (e) {

            productSliderBlock.init();

        })
		.on('shopify:block:select', function (e) {

			var blockTarget = e.originalEvent.target;
			productSliderBlock.select(blockTarget);

        })
        .on('shopify:block:deselect', function (e) {

            productSliderBlock.deselect();

        });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-50th-anniversary"]) return;
  try {
    
	$(document).ready(function(){
		$(".staff-block").first().prepend('<nav id="staff-block-nav"></nav>');
		$(".staff-block").each(function(){
			$('#staff-block-nav').append('<a class="staff-block-link" href="#'+$(this).attr('id')+'">'+$(this).find('.page-title').text()+'</a>');
		});

    	// smooth scroll to target
        jQuery('.staff-block-link').on('click',function (e) {
          e.preventDefault();

          var $headerHeight = $('nav.sticky').first().height();

          jQuery('html, body').stop().animate({
              'scrollTop': jQuery( jQuery.attr(this, 'href') ).offset().top - $headerHeight
          }, 500, 'swing' );
        });
	});

  } catch(e) { console.error(e); }
})();
})();
